import React, { createContext, useContext, useMemo } from 'react';

import { getBackendExperimentConfig } from '../services/statsig/backend';
import { type BackendExperiment, type BackendExperimentContextProps } from '../types';

const Context = createContext<BackendExperiment>(undefined);

export const BackendExperimentContext: ({
	children,
}: BackendExperimentContextProps) => React.JSX.Element = ({
	children,
}: BackendExperimentContextProps): React.JSX.Element => {
	const config = useMemo(() => getBackendExperimentConfig(), []);

	return <Context.Provider value={config}>{children}</Context.Provider>;
};

export const useBackendExperimentContext: () => BackendExperiment = () => {
	return useContext(Context);
};
